// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C6MYR","label":"styles_label__R2YGo"};